import React from "react";
import Messages from "./Messages";
import { defaultAlerts } from "../SidebarNavigation/utils/urgencyData";

class MessagesGrid extends React.Component {
    render() {
        const items = this.props.items || defaultAlerts;
        return (
            <div className="in-context-alerts-grid">
                {items.map((it, i) => (
                    <Messages
                        variant={it.variant}
                        key={`outline-${i}`}
                        style={it.style}
                        title={it.title}
                        description={it.description}
                    />
                ))}
            </div>
        );
    }
}

export default MessagesGrid;


// WEBPACK FOOTER //
// ./src/components/pages/in-context/components/MessagesGrid.js